import { COMBINED_KEY, platformColor, platformLabel } from './soundstatsHelpers';

// "All platforms" + per-platform chips used by every group renderer.

export default function PlatformChips({ entries, idx, onPick }) {
  if (!entries || entries.length === 0) return null;
  return (
    <div className="ss-plat-chips">
      {entries.map((entry, i) => {
        const isAll = entry.key === COMBINED_KEY;
        const color = platformColor(entry.key);
        return (
          <button
            key={entry.key}
            type="button"
            className={'ss-plat-chip' + (i === idx ? ' active' : '')}
            style={{ '--chip': color }}
            onClick={() => onPick(i)}
          >
            <span className="ss-pdot" />
            {isAll ? 'All platforms' : platformLabel(entry.key)}
          </button>
        );
      })}
    </div>
  );
}
